import { render, staticRenderFns } from "./BriefcaseIcon.vue?vue&type=template&id=5a85b6cd"
import script from "./BriefcaseIcon.vue?vue&type=script&lang=js"
export * from "./BriefcaseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports